angular.module('populationioApp').service('WorldPovertyIOService', [
	'$rootScope', '$http',
	function($rootScope, $http){
		'use strict';
		var baseUrl = 'http://api.povertyclock.staging.population.io/1.0';
		return {
			getWorldPoverty: function(args, onSuccess, onError){
				$http({
					method: 'get',
					url: baseUrl + '/poverty/world/' + args.date + '/' + args.seconds + '/?format=json'
				})
					.success(function(data){
						if(data && onSuccess){
							onSuccess(data);
						}
					})
					.error(function(){
						if(onError){
							onError();
						}
						console.error('getWorldPoverty() error');
					});
			}
		};
	}
]);
